var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"100%","height":"30vh"},attrs:{"id":'parent' + _vm.id}},[_c('canvas',{staticStyle:{"max-width":"100%","height":"auto"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }